module.exports = __webpack_public_path__ + "static/media/crowdfunding-icon-active.ccece28c.svg";